module.exports = (items, match) => {

  const loop = (items, index) => {

    if (index == -1) return -1

    return match(items[index])
      ? index
      : loop(items, index - 1)
  }

  return loop(items, items.length - 1)

}



// WEBPACK FOOTER //
// ../node_modules/berries/lib/findRightIndex.js